module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"noMeasure":"Keine Renovation","componentNameTitle":"Bauteil","insulationStandardTitle":"Wärmedämmung","basementNotExists":"Gebäude ist nicht unterkellert","costsTitle":"Kosten *","autoCostsHint":"Kosten leer lassen für automatische Kostenschätzung","missingRenovationStandardTooltip":"Der Renovationsstandard wurde zwischenzeitlich entfernt."}}')
  delete Component.options._Ctor
}
